import { Compliance } from "./Compliance";
import { TruckerContact } from "./TruckerContact";

export class Trucker {
    customerId: number = 0;
    customerCode: string = '';
    customerName: string = '';
    addressLine1: string = '';
    addressLine2: string | null = null;
    addressLine3: string | null = null;
    addressLine4: string | null = null;
    city: string = '';
    province: string = '';
    zipCode: string = '';
    countryCode: string = '';
    phone: string = '';
    isTelephone1TextEnabled: boolean = false;
    telephone1ValidationStatus: string = '';
    email: string = '';
    currency: string = '';
    comments: string | null = null;
    isRogerEnabled: boolean = false;
    isActive: boolean = false;
    hasCompliance: boolean = false;

    compliance: Compliance = new Compliance();
    contactList: TruckerContact[] = [];
}
